export const KO_MESSAGES = {
  "common.close": "닫기",
  "common.cancel": "취소",
  "common.apply": "적용",
  "common.yes": "예",
  "common.no": "아니오",
  "common.retry": "다시 시도",
  "common.notSelected": "선택 안 함",

  "lang.code": "KO",
  "lang.toggleLabel": "언어 변경",
  "lang.switchToEn": "English",
  "lang.switchToKo": "한국어",

  "meta.title": "데구르르 | Degururu",
  "meta.applicationName": "데구르르 | Degururu",
  "meta.description": "데구르르는 공이 떨어지며 당첨자를 정하는 핀볼 게임입니다. 치지직 핀볼, 스트리머 핀볼, 핀볼 사다리타기 콘텐츠부터 모임과 이벤트까지 가볍고 재미있게 활용해 보세요!",
  "meta.keywords": "데구르르, Degururu, 데구르르 게임, 치지직 핀볼, 스트리머 핀볼, 핀볼 게임, 핀볼 사다리타기, 참가자 선택, 파티 게임, 팀 선정",
  "meta.ogLocale": "ko_KR",
  "meta.ogImageAlt": "데구르르 핀볼 스타일 참가자 선택 게임 대표 이미지",
  "meta.structuredName": "데구르르",
  "meta.structuredInLanguage": "ko-KR",
  "meta.structuredKeywords": "데구르르 게임|치지직 핀볼|스트리머 핀볼|핀볼 게임|핀볼 사다리타기",
  "meta.structuredDescription": "데구르르는 공이 떨어지며 참가자를 선택하는 핀볼 게임입니다.",

  "pwa.updateReady": "새 버전이 준비되었습니다.",
  "pwa.update": "업데이트",

  "error.rootMissing": "루트 엘리먼트를 찾을 수 없습니다: {{selector}}",
  "error.canvasMissing": "게임 캔버스를 찾을 수 없습니다: {{selector}}",
  "error.fileRead": "파일을 읽지 못했습니다.",
  "error.uploadFailed": "이미지 업로드에 실패했습니다.",
  "error.network": "네트워크 오류가 발생했습니다.",

  "game.start": "게임 시작",
  "game.restart": "다시 시작",
  "game.pause": "일시정지",
  "game.resume": "이어하기",
  "game.startCaptionDefault": "두근두근 당첨자는 누구일까요?",
  "game.startPreparing": "준비 중...",

  "status.ready": "준비됨",
  "status.running": "진행 중",
  "status.paused": "일시 정지",
  "status.done": "결과 준비 완료",

  "left.menuOpen": "메뉴 열기",
  "left.menuClose": "메뉴 닫기",
  "left.minimap": "미니맵",
  "left.viewLock": "시점 고정",
  "left.viewLockEnable": "시점 고정 켜기",
  "left.viewLockDisable": "시점 고정 해제",
  "left.viewLockOn": "시점 고정 ON",
  "left.viewLockOff": "시점 고정 OFF",
  "left.minimapHint": "미니맵을 클릭해 이동하고, 시점 고정을 켜면 자동 추적으로 돌아갑니다.",
  "left.gameSettings": "게임 설정",
  "left.participantListTitle": "참가자 목록({{count}})",
  "left.participantFoldOpen": "참가자 목록 펼치기",
  "left.participantFoldClose": "참가자 목록 접기",
  "left.participantSettings": "참가자 설정",
  "left.startCaption": "시작지점 문구",
  "left.startCaptionFoldOpen": "시작지점 문구 펼치기",
  "left.startCaptionFoldClose": "시작지점 문구 접기",
  "left.startCaptionPlaceholder": "예) 두근두근 당첨자는 누구일까요?",
  "left.startCaptionLocked": "진행 중에는 변경할 수 없어요.",
  "left.startCaptionHint": "띄어쓰기 포함 최대 {{max}}자, 시작지점 상단에 표시됩니다.",
  "left.winnerCount": "당첨자 수",
  "left.winnerCountFoldOpen": "당첨자 수 펼치기",
  "left.winnerCountFoldClose": "당첨자 수 접기",
  "left.resultDisabledTip": "결과 보기는 게임 종료 이후 확인할 수 있습니다.",
  "left.openResult": "결과 보기",
  "left.resultHelper": "가장 늦게 도착한 순서대로 결과를 공개합니다.",
  "left.resultClamped": "참가자 수를 넘어 자동으로 참가자 수로 맞춰졌습니다.",
  "left.reorderAria": "{{name}} 순서 이동",
  "left.reorderLocked": "진행 중에는 순서를 변경할 수 없어요.",
  "left.reorderHint": "드래그해서 순서를 변경하세요.",
  "left.countAria": "{{name}} 개수",
  "left.editLocked": "진행 중에는 편집이 잠겨요",

  "topbar.stop": "중지",
  "topbar.stopTitle": "진행을 중지하고 초기화",
  "topbar.brandTitle": "데구르르 (Degururu)",
  "topbar.brandLabel": "데구르르",
  "topbar.speedOn": "2배속",
  "topbar.speedOff": "2배속 해제",
  "topbar.bgmOn": "BGM 켜기",
  "topbar.bgmOff": "BGM 끄기",
  "topbar.bgmTrack": "BGM 트랙 선택",
  "topbar.bgmMenu": "BGM 선택",
  "topbar.inquiryOpen": "문의하기 열기",
  "topbar.inquiry": "문의하기",

  "board.skip": "건너뛰기",
  "board.copyCoords": "좌표 복사",

  "settings.title": "참가자 설정",
  "settings.dirty": "변경됨",
  "settings.description": "참가자를 추가/삭제하고, 이름과 이미지를 바꿀 수 있어요.",
  "settings.addParticipant": "참가자 추가",
  "settings.reset": "설정 초기화",
  "settings.remove": "삭제",
  "settings.name": "이름",
  "settings.image": "이미지",
  "settings.uploadTitle": "이미지 업로드",
  "settings.uploadHint": "클릭해서 파일을 선택하세요",
  "settings.discardConfirm": "설정 변경을 취소하시겠습니까?",
  "settings.id": "ID",

  "inquiry.title": "문의하기",
  "inquiry.send": "메일 보내기",
  "inquiry.sending": "전송 중...",
  "inquiry.email": "이메일",
  "inquiry.subject": "제목",
  "inquiry.message": "내용",
  "inquiry.subjectPlaceholder": "문의 제목",
  "inquiry.messagePlaceholder": "문의 내용을 작성해 주세요.",
  "inquiry.website": "웹사이트",
  "inquiry.notice": "문의 응답을 위해 이메일, 제목, 내용이 수집됩니다. 보관기간 문의 처리 완료 후 최대 1년",
  "inquiry.privacy": "개인정보 처리방침 보기",
  "inquiry.alreadySubmitting": "이미 전송 중입니다.",
  "inquiry.sendDone": "메일 전송 완료",
  "inquiry.sendFail": "문의 전송에 실패했습니다.",
  "inquiry.sendSuccess": "문의가 정상적으로 전송되었습니다.",
  "inquiry.sendingStatus": "전송 중...",
  "inquiry.validation.emailRequired": "이메일을 입력해 주세요.",
  "inquiry.validation.emailInvalid": "이메일 형식이 올바르지 않습니다.",
  "inquiry.validation.subjectRequired": "제목을 입력해 주세요.",
  "inquiry.validation.messageRequired": "내용을 입력해 주세요.",
  "inquiry.validation.suspicious": "허용되지 않는 입력 형식이 포함되어 있습니다.",

  "result.listTitle": "당첨자 목록({{count}})",
  "result.waitingTitle": "결과 발표 대기중",
  "result.waitingBody": "결과를 준비하고 있어요.",
  "result.skipReveal": "바로 보기",
  "result.copy": "결과 복사",
  "result.restart": "다시 시작",

  "toast.resultCopied": "결과를 복사했습니다.",
  "toast.resultCopyFailed": "결과 복사에 실패했습니다.",
  "toast.networkError": "네트워크 오류",

  "upload.reselect": "파일을 다시 선택해 주세요.",
  "upload.type": "PNG/JPG/WEBP/GIF/AVIF 이미지 파일만 업로드할 수 있어요.",
  "upload.empty": "파일이 비어 있습니다. 다른 파일을 선택해 주세요.",
  "upload.maxSize": "이미지 파일은 최대 2MB까지 업로드할 수 있어요.",

  "minimap.hint.idle": "시작 전에도 미니맵으로 맵을 둘러볼 수 있어요.",
  "minimap.hint.playing": "토글 OFF: 자유 시점(미니맵으로 이동)\n토글 ON: 후미 공 자동 추적",

  "coord.pinnedSuffix": " (고정)",
  "coord.copyDone": "복사됨",
  "coord.copyFail": "실패",

  "ball.unknown": "알 수 없는 공",
  "ball.dog": "강아지",
  "ball.rabbit": "토끼",
  "ball.hamster": "햄스터",
  "ball.cat": "고양이",
  "ball.guineapig": "기니피그",
  "ball.panda": "판다",
  "ball.redpanda": "레서판다",
  "ball.capybara": "카피바라",
  "ball.quokka": "쿼카",
  "ball.otter": "수달",
  "ball.tiger": "호랑이",
  "ball.fox": "여우",
  "ball.magpie": "까치",
  "ball.elephant": "코끼리",
  "ball.penguin": "펭귄",

  "ui.noopSubmit": "구현되지 않았습니다.",

  "app.viewLockDisabled": "게임 시작 후 시점 고정을 사용할 수 있어요.",
  "app.viewLockEnabled": "켜면 후미 공 추적, 끄면 미니맵 이동",
} as const;

export const EN_MESSAGES: Record<keyof typeof KO_MESSAGES, string> = {
  "common.close": "Close",
  "common.cancel": "Cancel",
  "common.apply": "Apply",
  "common.yes": "Yes",
  "common.no": "No",
  "common.retry": "Retry",
  "common.notSelected": "Not selected",

  "lang.code": "EN",
  "lang.toggleLabel": "Switch language",
  "lang.switchToEn": "English",
  "lang.switchToKo": "Korean",

  "meta.title": "Degururu | Pinball Winner Picker",
  "meta.applicationName": "Degururu | Pinball Winner Picker",
  "meta.description": "Degururu is a pinball-style picker game where marbles drop to reveal winners. Great for streams, team picks, and event games.",
  "meta.keywords": "Degururu, pinball picker, winner picker, marble roulette, party game, team picker, stream game",
  "meta.ogLocale": "en_US",
  "meta.ogImageAlt": "Degururu pinball-style participant picker game preview image",
  "meta.structuredName": "Degururu",
  "meta.structuredInLanguage": "en-US",
  "meta.structuredKeywords": "pinball picker|winner picker|marble roulette|team picker|party game",
  "meta.structuredDescription": "Degururu is a pinball-style game that drops marbles to pick participants.",

  "pwa.updateReady": "A new version is ready.",
  "pwa.update": "Update",

  "error.rootMissing": "Root element not found: {{selector}}",
  "error.canvasMissing": "Game canvas not found: {{selector}}",
  "error.fileRead": "Could not read the file.",
  "error.uploadFailed": "Image upload failed.",
  "error.network": "A network error occurred.",

  "game.start": "Start",
  "game.restart": "Restart",
  "game.pause": "Pause",
  "game.resume": "Resume",
  "game.startCaptionDefault": "Who will be the lucky winner?",
  "game.startPreparing": "Get ready...",

  "status.ready": "Ready",
  "status.running": "Running",
  "status.paused": "Paused",
  "status.done": "Results ready",

  "left.menuOpen": "Open menu",
  "left.menuClose": "Close menu",
  "left.minimap": "Minimap",
  "left.viewLock": "Camera lock",
  "left.viewLockEnable": "Enable camera lock",
  "left.viewLockDisable": "Disable camera lock",
  "left.viewLockOn": "Camera lock ON",
  "left.viewLockOff": "Camera lock OFF",
  "left.minimapHint": "Click the minimap to move. Turn on camera lock to return to auto-tracking.",
  "left.gameSettings": "Game settings",
  "left.participantListTitle": "Participants ({{count}})",
  "left.participantFoldOpen": "Expand participants",
  "left.participantFoldClose": "Collapse participants",
  "left.participantSettings": "Edit participants",
  "left.startCaption": "Start caption",
  "left.startCaptionFoldOpen": "Expand start caption",
  "left.startCaptionFoldClose": "Collapse start caption",
  "left.startCaptionPlaceholder": "e.g.) Who will be the lucky winner?",
  "left.startCaptionLocked": "You cannot change this while a run is active.",
  "left.startCaptionHint": "Up to {{max}} chars including spaces. Shown above the start area.",
  "left.winnerCount": "Winner count",
  "left.winnerCountFoldOpen": "Expand winner count",
  "left.winnerCountFoldClose": "Collapse winner count",
  "left.resultDisabledTip": "You can open results after the run is finished.",
  "left.openResult": "View results",
  "left.resultHelper": "Results are revealed in order of latest arrival.",
  "left.resultClamped": "Winner count was clamped to participant count.",
  "left.reorderAria": "Reorder {{name}}",
  "left.reorderLocked": "Reordering is disabled during a run.",
  "left.reorderHint": "Drag to reorder.",
  "left.countAria": "{{name}} count",
  "left.editLocked": "Editing is locked while running",

  "topbar.stop": "Stop",
  "topbar.stopTitle": "Stop current run and reset",
  "topbar.brandTitle": "Degururu",
  "topbar.brandLabel": "Degururu",
  "topbar.speedOn": "2x speed",
  "topbar.speedOff": "Disable 2x speed",
  "topbar.bgmOn": "Turn BGM on",
  "topbar.bgmOff": "Turn BGM off",
  "topbar.bgmTrack": "Select BGM track",
  "topbar.bgmMenu": "BGM tracks",
  "topbar.inquiryOpen": "Open inquiry",
  "topbar.inquiry": "Inquiry",

  "board.skip": "Skip",
  "board.copyCoords": "Copy coords",

  "settings.title": "Participant settings",
  "settings.dirty": "Modified",
  "settings.description": "Add/remove participants and edit names/images.",
  "settings.addParticipant": "Add participant",
  "settings.reset": "Reset to default",
  "settings.remove": "Remove",
  "settings.name": "Name",
  "settings.image": "Image",
  "settings.uploadTitle": "Upload image",
  "settings.uploadHint": "Click to choose a file",
  "settings.discardConfirm": "Discard your settings changes?",
  "settings.id": "ID",

  "inquiry.title": "Contact",
  "inquiry.send": "Send mail",
  "inquiry.sending": "Sending...",
  "inquiry.email": "Email",
  "inquiry.subject": "Subject",
  "inquiry.message": "Message",
  "inquiry.subjectPlaceholder": "Inquiry subject",
  "inquiry.messagePlaceholder": "Write your message.",
  "inquiry.website": "Website",
  "inquiry.notice": "Email, subject, and message are collected only to reply to your inquiry and kept for up to one year.",
  "inquiry.privacy": "View privacy policy",
  "inquiry.alreadySubmitting": "Already submitting.",
  "inquiry.sendDone": "Mail sent.",
  "inquiry.sendFail": "Failed to send inquiry.",
  "inquiry.sendSuccess": "Inquiry sent successfully.",
  "inquiry.sendingStatus": "Sending...",
  "inquiry.validation.emailRequired": "Please enter your email.",
  "inquiry.validation.emailInvalid": "Please enter a valid email address.",
  "inquiry.validation.subjectRequired": "Please enter a subject.",
  "inquiry.validation.messageRequired": "Please enter a message.",
  "inquiry.validation.suspicious": "Input contains a disallowed pattern.",

  "result.listTitle": "Winners ({{count}})",
  "result.waitingTitle": "Waiting for reveal",
  "result.waitingBody": "Preparing results.",
  "result.skipReveal": "Reveal now",
  "result.copy": "Copy results",
  "result.restart": "Restart",

  "toast.resultCopied": "Results copied.",
  "toast.resultCopyFailed": "Failed to copy results.",
  "toast.networkError": "Network error",

  "upload.reselect": "Please select the file again.",
  "upload.type": "Only PNG/JPG/WEBP/GIF/AVIF image files are allowed.",
  "upload.empty": "The file is empty. Please choose another file.",
  "upload.maxSize": "Image files can be up to 2MB.",

  "minimap.hint.idle": "You can explore the map with the minimap before starting.",
  "minimap.hint.playing": "Toggle OFF: free camera (move via minimap)\nToggle ON: auto-track trailing marble",

  "coord.pinnedSuffix": " (pinned)",
  "coord.copyDone": "Copied",
  "coord.copyFail": "Failed",

  "ball.unknown": "Unknown ball",
  "ball.dog": "Dog",
  "ball.rabbit": "Rabbit",
  "ball.hamster": "Hamster",
  "ball.cat": "Cat",
  "ball.guineapig": "Guinea Pig",
  "ball.panda": "Panda",
  "ball.redpanda": "Red Panda",
  "ball.capybara": "Capybara",
  "ball.quokka": "Quokka",
  "ball.otter": "Otter",
  "ball.tiger": "Tiger",
  "ball.fox": "Fox",
  "ball.magpie": "Magpie",
  "ball.elephant": "Elephant",
  "ball.penguin": "Penguin",

  "ui.noopSubmit": "Not implemented.",

  "app.viewLockDisabled": "Camera lock is available after the game starts.",
  "app.viewLockEnabled": "On: trailing marble tracking, Off: minimap camera control",
};

export const MESSAGES = {
  ko: KO_MESSAGES,
  en: EN_MESSAGES,
} as const;

export type MessageKey = keyof typeof KO_MESSAGES;
